import { useSelector } from "react-redux";
import { apiCreateProcessSupport } from "../api/methods/process";

export function useFormFeedback() {
  const { mobileConnectionInfo } = useSelector(state => state);

  /**
   * Отправить заявку на обратный звонок
   */
  const sendFormFeedback = async (userName, userPhoneNumber, userAddress, url, userComment) => {
    await apiCreateProcessSupport(
      userName,
      userPhoneNumber,
      userAddress,
      mobileConnectionInfo.city?.title,
      url,
      userComment
    );
  };

  return {
    sendFormFeedback,
  };
}
